import {
  NormalQuestionBubble,
  QuestionBubbleHeader,
  QuestionBubbleLabel,
} from "@/Shared/Components/QuestionBubble";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface AddressQuestionBubbleProps {
  displayName?: string | undefined;
  context: LocationContext;
  onModify: () => void;
  location: AddLocationLocationType;
}

const BookShipmentAddressQuestionBubble: React.FC<
  AddressQuestionBubbleProps
> = (props: AddressQuestionBubbleProps) => {
  const { location } = props;
  function zipcodeOrPostalCode() {
    if (location.address.countryCode === CountryCode.UnitedStates) {
      return "zip code";
    }

    if (location.address.countryCode === CountryCode.Canada) {
      return "postal code";
    }

    throw new Error("Unknown country");
  }

  function header() {
    if (props.displayName) {
      const displayName = props.displayName.toLowerCase();
      return `Enter address information for ${displayName}`;
    } else {
      return `Enter address information`;
    }
  }

  const locationString = props.context?.toLowerCase() || "this location";

  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>{header()}</QuestionBubbleHeader>
          <QuestionBubbleLabel>
            Enter contact information for {locationString}. The carrier may need
            to contact this person for various reasons, such as booking an
            appointment or finding the door.
          </QuestionBubbleLabel>
          <QuestionBubbleLabel>
            This quote is only valid for the current {zipcodeOrPostalCode()}. To
            change the {zipcodeOrPostalCode()} and get a new quote,{" "}
            <Button size="link" onClick={props.onModify} inheritFont={true}>
              click here
            </Button>
          </QuestionBubbleLabel>
        </>
      }
      learnMoreUrl="https://help.freightsimple.com/using-freightsimple/booking-your-shipment/pickup-and-delivery-addresses-and-hours"
    />
  );
};
export default BookShipmentAddressQuestionBubble;
